"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultClassActivator = exports.ClassActivator = void 0;
class ClassActivator {
}
exports.ClassActivator = ClassActivator;
class DefaultClassActivator extends ClassActivator {
    activate(type) {
        return new type();
    }
}
exports.DefaultClassActivator = DefaultClassActivator;
//# sourceMappingURL=ClassActivator.js.map